/**
 * FlagFilterModal - Modal single-select para filtrar por flag
 */
import React from 'react'
import { FLAG_OPTIONS } from '../../utils/flagOptions'

export default function FlagFilterModal({ currentFilter, onSelect, onClose }) {
  const handleSelect = (id) => {
    onSelect(id)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white dark:bg-surface-dark-alt rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
        {/* Header - orange gradient to distinguish */}
        <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 px-6 py-4">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="3 4 21 4 14 14 14 20 10 22 10 14 3 4" />
            </svg>
            Filtrar por flag
          </h3>
          <p className="text-white/80 text-sm mt-1">Selecciona un flag para mostrar solo esos contactos</p>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="grid grid-cols-5 gap-3">
            {FLAG_OPTIONS.map(flag => {
              const isSelected = currentFilter === flag.key
              return (
                <button
                  key={flag.key}
                  onClick={() => handleSelect(flag.key)}
                  className={`flex flex-col items-center gap-1.5 p-3 rounded-xl transition-all duration-200 transform hover:scale-105 active:scale-95 ${
                    isSelected
                      ? 'bg-gradient-to-br from-amber-200 to-orange-200 border-2 border-orange-500 shadow-lg dark:from-amber-900/50 dark:to-orange-900/50'
                      : 'bg-white dark:bg-slate-800 border-2 border-gray-200 dark:border-slate-600 hover:border-orange-300 dark:hover:border-orange-500 hover:shadow-md'
                  }`}
                  title={flag.label}
                >
                  {flag.render('lg')}
                  <span className="text-xs font-medium text-gray-700 dark:text-gray-300 truncate w-full text-center">{flag.label}</span>
                </button>
              )
            })}
          </div>

          {/* Sin flag option */}
          <div className="pt-3 mt-3 border-t border-gray-200 dark:border-gray-700">
            <button
              onClick={() => handleSelect('none')}
              className={`w-full px-4 py-2.5 rounded-xl text-sm font-medium transition ${
                currentFilter === 'none'
                  ? 'bg-gradient-to-r from-amber-200 to-orange-200 text-orange-900 border-2 border-orange-500 dark:from-amber-900/50 dark:to-orange-900/50 dark:text-orange-200'
                  : 'bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 border-2 border-gray-200 dark:border-slate-600 hover:bg-gray-200 dark:hover:bg-slate-600'
              }`}
            >
              &#x2014; Sin flag asignado
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  )
}
